import { type Row as RowType } from '@tanstack/react-table';
import React, { type FC } from 'react';
import { Collapse } from '../../../../Collapse';
import { DataTableProps } from '../../../DataTableTypes';
import { Row } from './Row';

interface RowsProps {
  rows: RowType<object>[];
  slotProps: DataTableProps<any>['slotProps'];
}

export const Rows: FC<RowsProps> = ({ rows = [], slotProps }) => {
  return rows.map((row) => {
    const extraRows = row.getCanExpand() && slotProps?.expandableRow?.render ? row.getLeafRows() : [];

    return (
      <React.Fragment key={row.id}>
        <Row row={row} expanded={row.getIsExpanded()} selected={row.getIsSelected()} />
        {!!extraRows?.length && (
          <Collapse in={row.getIsExpanded()}>
            <span>{slotProps?.expandableRow?.render(row.original)}</span>
          </Collapse>
        )}
      </React.Fragment>
    );
  });
};
